import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import {Check, X, CashCoin} from "react-bootstrap-icons";
import { BsCashStack } from "react-icons/bs";
import { TbFlagQuestion } from "react-icons/tb";
import {BiLogoVenmo, BiMoneyWithdraw} from "react-icons/bi";
import {SiCashapp, SiPaypal, SiZelle} from "react-icons/si";
import PropTypes from "prop-types";

import useLongPress from "../../../hooks/useLongPress";
import { formatMoney } from "../../../utilities/common";

import "./TransactionDetail.css";
import {PiHandDeposit} from "react-icons/pi";
import {RiDeviceRecoverLine} from "react-icons/ri";
import {CiCircleQuestion} from "react-icons/ci";
import {DeleteButton} from "../../../components/DeleteButton";
import { useHouseDispatch } from "../../../contexts/HouseContext";

export function TransactionDetail({ gameId, playerId, transaction, netAmount }) {
    const actions = useHouseDispatch();

    let [showDelete, setShowDelete] = useState(false);

    let buyIn = '';
    let cashOut = '';
    let net = '';

    switch (transaction.type) {
        case 'BUY_IN':
            buyIn = transaction.amount.toFixed(2)
            cashOut = '';
            net = (netAmount / 100).toFixed(2)
            break;
        case 'CASH_OUT':
        case 'COVER':
            buyIn = '';
            cashOut = transaction.amount.toFixed(2);
            net = (netAmount / 100).toFixed(2)
            break;
        default:
            buyIn = '';
            cashOut = '';
            net = (netAmount / 100).toFixed(2)
    }

    const onLongPress = () => {
        setShowDelete(true);
    }

    const onClick = () => {
        if (showDelete) {
            setShowDelete(false);
        }
    }

    const longPressEventHandler = useLongPress({onLongPress, onClick})

    const toggleTransactionStatus = async () => {
        const updatedTxn = {...transaction, isSettled: !transaction.isSettled};
        await actions.toggleTransactionStatus(gameId, playerId, updatedTxn);
    }

    const handleDelete = async () => {
        await actions.deleteTransaction(gameId, playerId, transaction)
    }

    return (
        <Row className="p-2 detail position-relative" {...longPressEventHandler}>
            <Col xs={3} md={4}><TransactionStatus gameId={gameId} playerId={playerId} transaction={transaction} onStatusToggle={toggleTransactionStatus}/></Col>
            <Col xs={3} md={2} className="money">{formatMoney(buyIn)}</Col>
            <Col xs={3} md={2} className="money">{formatMoney(cashOut)}</Col>
            <Col xs={3} md={2} className="money position-relative">
                {formatMoney(net)}
                <DeleteButton show={showDelete} handleDelete={handleDelete} />
            </Col>
        </Row>
    );
}

TransactionDetail.propTypes = {
    gameId: PropTypes.string,
    transaction: PropTypes.object,
    netAmount: PropTypes.number,
    handleTransactionDelete: PropTypes.func,
}

function TransactionStatus({ gameId, playerId, transaction, onStatusToggle }) {
    let [showPaymentTypePicker, setShowPaymentTypePicker] = useState(false);
    const actions = useHouseDispatch();

    const handlePaymentTypeChange = async (newPaymentType) => {
        const updatedTxn = { ...transaction, paymentType: newPaymentType };
        await actions.changeTransaction(gameId, playerId, updatedTxn);
        setShowPaymentTypePicker(false);
    };

    let transactionType;
    // let tTypeDescription;

    switch (transaction.type) {
        case 'BUY_IN':
            transactionType = <PiHandDeposit className='text-success'/>;
            // tTypeDescription = "Buy In"
            break;
        case 'CASH_OUT':
            transactionType = <BiMoneyWithdraw className='text-danger'/>;
            // tTypeDescription = "Cash Out"
            break;
        case 'COVER':
            transactionType = <RiDeviceRecoverLine className='text-warning'/>;
            // tTypeDescription = "Covered Transaction"
            break;
        default:
            transactionType = <CiCircleQuestion/>;
    }

    const PaymentTypePicker = () => (
        <div className="payment-type-picker">
            <div onClick={() => handlePaymentTypeChange('CASH')} className="payment-option">
                <CashCoin/>
            </div>
            <div onClick={() => handlePaymentTypeChange('CASH_APP')} className="payment-option">
                <SiCashapp title="CashApp"/>
            </div>
            <div onClick={() => handlePaymentTypeChange('PAYPAL')} className="payment-option">
                <SiPaypal title="PayPal"/>
            </div>
            <div onClick={() => handlePaymentTypeChange('VENMO')} className="payment-option">
                <BiLogoVenmo title="Venmo"/>
            </div>
            <div onClick={() => handlePaymentTypeChange('ZELLE')} className="payment-option">
                <SiZelle title="Zelle"/>
            </div>
        </div>
    );

    return (
        <div className="transaction-status">
            <Col>{transactionType}</Col>
            <Col onClick={() => setShowPaymentTypePicker(!showPaymentTypePicker)}>
                {showPaymentTypePicker 
                    ? <PaymentTypePicker />
                    : <PaymentType paymentType={transaction.paymentType}/>
                }
            </Col>
            <Col onClick={onStatusToggle}>
                <Badge bg={transaction.isSettled ? "success" : "warning"}>
                    {transaction.isSettled ? <Check/> : <X/>}
                </Badge>
            </Col>
        </div>
    );
}

const PaymentType = ({ paymentType }) => {
    switch (paymentType) {
        case 'CASH':
            return <BsCashStack title={"Cash"} />
        case 'CASH_APP':
            return <SiCashapp title={"CashApp"} />
        case 'PAYPAL':
            return <SiPaypal title={"PayPal"} />
        case 'VENMO':
            return <BiLogoVenmo title={"Venmo"} />
        case 'ZELLE':
            return <SiZelle title={"Zelle"} />
        default:
            return <TbFlagQuestion title={"Unknown"} />
    }
}

TransactionStatus.propTypes = {
    transaction: PropTypes.object,
    onStatusToggle: PropTypes.func,
}
